import { logStartGreyError } from 'owa-analytics-start';
import type {
    NavigatorWithStorageBuckets,
    StorageBucketOptions,
    StorageBucket,
} from './StorageBucket';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export async function getStorageBucket(
    name: string,
    options: StorageBucketOptions = { persisted: true, durability: 'relaxed' }
): Promise<StorageBucket | null> {
    const nav = navigator as NavigatorWithStorageBuckets;

    if (!nav.storageBuckets?.open) {
        return null;
    }

    try {
        const bucket = await nav.storageBuckets.open(name, options);
        return bucket;
    } catch (error) {
        // Using getGlobalSettingsAccountMailboxInfo: This is infrastructure telemetry about
        // storage bucket errors. This runs at storage initialization level
        // before user data context is established.
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'Error | undefined'.
        // @ts-expect-error
        logStartGreyError('GetStorageBucket', getGlobalSettingsAccountMailboxInfo(), error);
        return null;
    }
}
